export default __webpack_public_path__ + "static/media/testimonial1.051963a6.png";